import { render, staticRenderFns } from "./ClueRemark.vue?vue&type=template&id=1ae613c4&scoped=true"
import script from "./ClueRemark.vue?vue&type=script&lang=js"
export * from "./ClueRemark.vue?vue&type=script&lang=js"
import style0 from "./ClueRemark.vue?vue&type=style&index=0&id=1ae613c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae613c4",
  null
  
)

export default component.exports